import React from "react";
import './App.css';
import { connect } from 'react-redux'

import { socket, nominateChancellor, setTransition } from './actions';

import DecisionModal from './DecisionModal';
import PresidentialModal from './PresidentialModal';
import VetoModal from './VetoModal';

import JaiVote from "./static/JaiVote.png";
import NeinVote from "./static/NeinVote.png";

import President from "./static/President.png";
import Chancellor from "./static/Chancellor.png";
import NominatedChancellor from "./static/NominatedChancellor.png";

import LiberalPartyCard from "./static/LiberalPartyCard.png";
import LiberalRoleCard from "./static/LiberalRoleCard.png";

import FascistPartyCard from "./static/FacistPartyCard.png";
import FascistRoleCard from "./static/FascistRoleCard.png";
import DictatorRoleCard from "./static/DictatorRoleCard.png";

import FacistBoard_small_0 from "./static/FacistBoard_small_0.png";
import FacistBoard_small_1 from "./static/FacistBoard_small_1.png";
import FacistBoard_small_2 from "./static/FacistBoard_small_2.png";
import FacistBoard_small_3 from "./static/FacistBoard_small_3.png";
import FacistBoard_small_4 from "./static/FacistBoard_small_4.png";
import FacistBoard_small_5 from "./static/FacistBoard_small_5.png";
import FacistBoard_small_6 from "./static/FacistBoard_small_6.png";

import FacistBoard_medium_0 from "./static/FacistBoard_medium_0.png";
import FacistBoard_medium_1 from "./static/FacistBoard_medium_1.png";
import FacistBoard_medium_2 from "./static/FacistBoard_medium_2.png";
import FacistBoard_medium_3 from "./static/FacistBoard_medium_3.png";
import FacistBoard_medium_4 from "./static/FacistBoard_medium_4.png";
import FacistBoard_medium_5 from "./static/FacistBoard_medium_5.png";
import FacistBoard_medium_6 from "./static/FacistBoard_medium_6.png";

import FacistBoard_large_0 from "./static/FacistBoard_large_0.png";
import FacistBoard_large_1 from "./static/FacistBoard_large_1.png";
import FacistBoard_large_2 from "./static/FacistBoard_large_2.png";
import FacistBoard_large_3 from "./static/FacistBoard_large_3.png";
import FacistBoard_large_4 from "./static/FacistBoard_large_4.png";
import FacistBoard_large_5 from "./static/FacistBoard_large_5.png";
import FacistBoard_large_6 from "./static/FacistBoard_large_6.png";

import LiberalBoard_0 from "./static/LiberalBoard_0.png";
import LiberalBoard_1 from "./static/LiberalBoard_1.png";
import LiberalBoard_2 from "./static/LiberalBoard_2.png";
import LiberalBoard_3 from "./static/LiberalBoard_3.png";
import LiberalBoard_4 from "./static/LiberalBoard_4.png";
import LiberalBoard_5 from "./static/LiberalBoard_5.png";

import ElectionTracker_0 from "./static/ElectionTracker_0.png";
import ElectionTracker_1 from "./static/ElectionTracker_1.png";
import ElectionTracker_2 from "./static/ElectionTracker_2.png";
import ElectionTracker_3 from "./static/ElectionTracker_3.png";

const facistLargeBoards = [
  FacistBoard_large_0,
  FacistBoard_large_1,
  FacistBoard_large_2,
  FacistBoard_large_3,
  FacistBoard_large_4,
  FacistBoard_large_5,
  FacistBoard_large_6
]

const facistMediumBoards = [
  FacistBoard_medium_0,
  FacistBoard_medium_1,
  FacistBoard_medium_2,
  FacistBoard_medium_3,
  FacistBoard_medium_4,
  FacistBoard_medium_5,
  FacistBoard_medium_6
]

const facistSmallBoards = [
  FacistBoard_small_0,
  FacistBoard_small_1,
  FacistBoard_small_2,
  FacistBoard_small_3,
  FacistBoard_small_4,
  FacistBoard_small_5,
  FacistBoard_small_6
]

const facistBoardsMap = {
  0: facistSmallBoards,
  1: facistSmallBoards,
  2: facistSmallBoards,
  3: facistSmallBoards,
  4: facistSmallBoards,
  5: facistSmallBoards,
  6: facistSmallBoards,
  7: facistMediumBoards,
  8: facistMediumBoards,
  9: facistLargeBoards,
  10: facistLargeBoards
}

const liberalBoards = [
  LiberalBoard_0,
  LiberalBoard_1,
  LiberalBoard_2,
  LiberalBoard_3,
  LiberalBoard_4,
  LiberalBoard_5,
]

const electionTracker = [
  ElectionTracker_0,
  ElectionTracker_1,
  ElectionTracker_2,
  ElectionTracker_3
]

class Game extends React.Component {

  constructor(props) {
    super(props);
    this.state = { lastScore: undefined }
  }

  componentDidUpdate(prevProps) {

    if ((this.props && prevProps) && (this.props.num_fascist_laws_passed > prevProps.num_fascist_laws_passed)) {
      this.setState({ lastScore: "Fascist" });
    } else if (this.props.num_liberal_laws_passed > prevProps.num_liberal_laws_passed) {
      this.setState({ lastScore: "Liberal" });
    }

    if ((this.props && prevProps) && (this.props.state !== prevProps.state)) {

      switch (prevProps.state + "-->" + this.props.state) {

        case "undefined-->NOMINATION":
          var president = this.props.players[this.props.president];
          this.props.setTransition(`Let's play. Our president is ${president.name}.`);
          break;

        case "VOTING-->CHOOSE_LAWS":
          var chancellor = this.props.players[this.props.chancellor];
          this.props.setTransition(`${chancellor.name} was elected Chancellor.`);
          break;

        case "VOTING-->NOMINATION":
          var president = this.props.players[this.props.president];
          if (prevProps.num_fascist_laws_passed < this.props.num_fascist_laws_passed) {
            this.props.setTransition(`Election Failed. Fascist policy passed. Our next President is ${president.name}.`);
          } else if (prevProps.num_liberal_laws_passed < this.props.num_liberal_laws_passed) {
            this.props.setTransition(`Election Failed. Liberal policy passed. Our next President is ${president.name}.`);
          } else {
            this.props.setTransition(`Election Failed. Our next President is ${president.name}.`);
          }
          break;

        case "PASS_LAW-->PRESIDENTIAL_POWER":
          this.props.setTransition(`Fascist policy passed. Presidential Power unlocked!`);
          break;

        case "PASS_LAW-->NOMINATION":
          var president = this.props.players[this.props.president];
          this.props.setTransition(`${this.state.lastScore} policy passed. Our next President will be ${president.name}.`);
          break;

        case "PRESIDENTIAL_POWER-->NOMINATION":
          var president = this.props.players[this.props.president];
          this.props.setTransition(`Our next President will be ${president.name}.`);
          break;

        case "PRESIDENT_VETO-->NOMINATION":
          var president = this.props.players[this.props.president];
          this.props.setTransition(`The government chose to veto the policies. Our next President will be ${president.name}.`);
          break;

        case "PRESIDENT_VETO-->PASS_LAW":
          var president = this.props.players[this.props.president];
          this.props.setTransition(`President ${president.name} denied the veto.`);
          break;

        default:
          break;
      }
    }

  }

  render() {
    var gameMessage = "";
    var actionModal = undefined;

    var president = this.props.players[this.props.president] || { name: "" };
    var chancellor = this.props.players[this.props.chancellor] || { name: "" };
    var nominated_chancellor = this.props.players[this.props.nominated_chancellor] || { name: "" };

    if (this.props.transition_message) {

      gameMessage = this.props.transition_message;

    } else {
      /////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// NOMINATE A CHANCELLOR MODAL ///////////////////////////
      ///////////////////////////////////////////////////////////////////////////////////
      if (this.props.state === "NOMINATION") {
        if (this.props.playerID === this.props.president) {

          // Identify potential chancellors: Filter self, assassinated characters, previous government
          var potentialChancellors = Object.assign({}, this.props.players);
          delete potentialChancellors[this.props.playerID];
          for (var i in this.props.assassinated_players) { delete potentialChancellors[this.props.assassinated_players[i]]; }
          if (Object.keys(this.props.players).length > 2) { // DEBUG
            for (var i in this.props.previous_government) { delete potentialChancellors[this.props.previous_government[i]]; }
          }
          potentialChancellors = Object.values(potentialChancellors);

          actionModal = (
            <DecisionModal
              prompt={`President ${president.name},<br>nominate your chancellor.`}
              choices={potentialChancellors}
              numChoices={1}
              choiceType={"people"}
              onSubmit={(selectedIndices) => {
                if (selectedIndices.length > 0) {
                  socket.emit("nominate chancellor", potentialChancellors[selectedIndices[0]].id);
                }
              }}
              submitLabel={"NOMINATE"}
            />);
        } else {
          gameMessage = `President ${president.name} is nominating a Chancellor.`;
        }
      }

      ///////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////////////// VOTING //////////////////////////////////////
      ///////////////////////////////////////////////////////////////////////////////////
      if (this.props.state === "VOTING") {
        gameMessage = `${nominated_chancellor.name} was nominated as Chancellor. VOTE NOW!`;
      }

      /////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// PRESIDENT CHOOSES LAWS ///////////////////////////
      ///////////////////////////////////////////////////////////////////////////////////    
      if (this.props.state === "CHOOSE_LAWS") {
        if (this.props.playerID === this.props.president) {
          actionModal = (
            <DecisionModal
              prompt={`President ${president.name},<br>choose 2 policies to send to Chancellor ${chancellor.name}`}
              choices={this.props.lawChoices}
              numChoices={2}
              choiceType={"laws"}
              onSubmit={(selectedIndices) => {
                var selections = this.props.lawChoices.map((selection, index) => {
                  return selectedIndices.includes(index)
                });
                socket.emit("filter laws", selections);
              }}
              submitLabel={"SEND"}
            />);
        } else {
          gameMessage = `President ${president.name} is choosing 2 policies to send to Chancellor ${chancellor.name}.`;
        }
      }

      /////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// CHANCELLOR PASSES LAW ///////////////////////////////
      /////////////////////////////////////////////////////////////////////////////////
      if (this.props.state === "PASS_LAW") {
        if (this.props.playerID === this.props.chancellor) {
          actionModal = (
            <DecisionModal
              prompt={`Chancellor ${chancellor.name}, choose 1 policy to pass.`}
              choices={this.props.lawChoices}
              numChoices={1}
              choiceType={"laws"}
              onSubmit={(selectedIndices) => {
                var selections = this.props.lawChoices.map((selection, index) => {
                  return selectedIndices.includes(index)
                });
                socket.emit("pass law", selections);
              }}
              submitLabel={"PASS"}
            />);
        } else {
          gameMessage = `Chancellor ${chancellor.name} is choosing a policy to pass.`;
        }
      }

      /////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// CHANCELLOR HAS CHANCE TO VETO ///////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////
      if (this.props.state === "CHANCELLOR_VETO") {
        if (this.props.playerID === this.props.chancellor) {
          actionModal = (
            <VetoModal
              prompt={"Do you wish to veto this agenda?"}
              laws={this.props.lawChoices}
              veto={(veto) => { socket.emit("veto", veto); }}
            />);
        } else {
          gameMessage = `Chancellor ${chancellor.name} is choosing a policy to pass.`;
        }
      }

      /////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// PRESIDENT HAS CHANCE TO VETO ///////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////
      if (this.props.state === "PRESIDENT_VETO") {
        if (this.props.playerID === this.props.president) {
          actionModal = (
            <VetoModal
              prompt={`Chancellor ${chancellor.name} moved to veto.<br>President ${president.name}, do you agree to veto?`}
              laws={[this.props.lawChoices]}
              veto={(veto) => { socket.emit("veto", veto); }}
            />);
        } else {
          gameMessage = `Chancellor wishes to veto. The decision now rests with the President.`;
        }
      }


      /////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// PRESIDENT PEEKS CARDS ///////////////////////////
      ///////////////////////////////////////////////////////////////////////////////////
      if (this.props.state === "PRESIDENTIAL_POWER" && this.props.presidential_power === "POLICY_PEEK") {

        if (this.props.playerID === this.props.president) {
          actionModal = (
            <PresidentialModal
              prompt={`PRESIDENTIAL POWER UNLOCKED<br>President ${president.name}, here are the next 3 policies.`}
              items={this.props.peek_cards}
              itemType={"laws"}
              submitLabel={"DONE"}
              onSubmit={() => { socket.emit("presidential power", ""); }}
            />);
        } else {
          gameMessage = `President ${president.name} is viewing the next 3 policies.`;
        }
      }


      /////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// PRESIDENT INVESTIGATES PLAYER ///////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////
      if (this.props.state === "PRESIDENTIAL_POWER" && this.props.presidential_power === "INVESTIGATE") {

        // Identify potential peeks: Filter self, assassinated characters
        var potentialPeeks = Object.assign({}, this.props.players);
        delete potentialPeeks[this.props.playerID];
        for (var i in this.props.assassinated_players) { delete potentialPeeks[this.props.assassinated_players[i]]; }
        potentialPeeks = Object.values(potentialPeeks);

        if (this.props.playerID === this.props.president) {
          actionModal = (
            <DecisionModal
              prompt={`PRESIDENTIAL POWER UNLOCKED<br>President ${president.name}, select a player to investigate.`}
              choices={potentialPeeks}
              numChoices={1}
              choiceType={"people"}
              onSubmit={(selectedIndices) => {
                if (selectedIndices.length > 0) {
                  socket.emit("presidential power", potentialPeeks[selectedIndices[0]].id);
                }
              }}
              submitLabel={"REVEAL PARTY"}
            />);
        } else {
          gameMessage = `President ${president.name} is choosing a player to investigate.`;
        }
      }

      //////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// PRESIDENT SPECIAL ELECT    ///////////////////////////
      //////////////////////////////////////////////////////////////////////////////////
      if (this.props.state === "PRESIDENTIAL_POWER" && this.props.presidential_power === "SPECIAL_ELECT") {

        // Identify potential peeks: Filter self, assassinated characters
        var potentialPresidents = Object.assign({}, this.props.players);
        delete potentialPresidents[this.props.playerID];
        for (var i in this.props.assassinated_players) { delete potentialPresidents[this.props.assassinated_players[i]]; }
        potentialPresidents = Object.values(potentialPresidents);

        if (this.props.playerID === this.props.president) {
          actionModal = (
            <DecisionModal
              prompt={`PRESIDENTIAL POWER UNLOCKED<br>President ${president.name}, choose the next President.`}
              choices={potentialPresidents}
              numChoices={1}
              choiceType={"people"}
              onSubmit={(selectedIndices) => {
                if (selectedIndices.length > 0) {
                  socket.emit("presidential power", potentialPresidents[selectedIndices[0]].id);
                }
              }}
              submitLabel={"ELECT"}
            />);
        } else {
          gameMessage = `President ${president.name} is choosing the next President.`;
        }
      }
    }


    /////////////////////////////////////////////////////////////////////////////////
    /////////////////////////// PRESIDENT ASSASSINATES ///////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////
    if (this.props.state === "PRESIDENTIAL_POWER" && this.props.presidential_power === "ASSASSINATE") {

      // Identify potential peeks: Filter self, assassinated characters
      var potentialAssassinations = Object.assign({}, this.props.players);
      delete potentialAssassinations[this.props.playerID];
      for (var i in this.props.assassinated_players) { delete potentialAssassinations[this.props.assassinated_players[i]]; }
      potentialAssassinations = Object.values(potentialAssassinations);

      if (this.props.playerID === this.props.president) {
        actionModal = (
          <DecisionModal
            prompt={`PRESIDENTIAL POWER UNLOCKED<br>President ${president.name}, choose a player to assassinate.`}
            choices={potentialAssassinations}
            numChoices={1}
            choiceType={"people"}
            onSubmit={(selectedIndices) => {
              if (selectedIndices.length > 0) {
                socket.emit("presidential power", potentialAssassinations[selectedIndices[0]].id);
              }
            }}
            submitLabel={"ASSASSINATE"}
          />);
      } else {
        gameMessage = `President ${president.name} is choosing a player to assassinate.`;
      }
    }

    ///////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////       GAME ENDS        ////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////
    if (this.props.state === "GAME_END") {
      gameMessage = `${this.props.winners}S WIN. ${this.props.win_reason.split("_").join(" ")}.`;
    }

    return (
      <React.Fragment>

        {actionModal}

        <div className="center" style={{ position: 'absolute', top: 120, left: 0, right: 0, bottom: 300 }}>

          <div className="headerText" style={{ fontSize: 30, textAlign: 'center', marginBottom: 30, marginTop: 30 }}>{gameMessage}</div>

          <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'flexStart' }}>

            { /* /////////////////////////////////////////////// */}
            { /* //////////////   PLAYER TABLE  //////////////// */}
            { /* /////////////////////////////////////////////// */}

            <div style={{ flex: 1, height: '100%', marginLeft: 20, maxHeight: 480, overflowY: 'scroll', minWidth: 305, maxWidth: 305 }}>
              <table className="playerTable" style={{ flex: 1 }}>
                <tbody>
                  {Object.keys(this.props.players).map((playerID) => {
                    var player = this.props.players[playerID];
                    return (
                      <React.Fragment>
                      <tr key={player.id} style={{ height: 50 }}>
                        <td style={{ textAlign: 'center', fontSize: 24, width: 35 }}>
                          {player.id === this.props.playerID && " ⭐ "}
                          {this.props.assassinated_players.includes(player.id) && " 💀 "}
                          {this.props.player_investigated === player.id && <span className="bounce">🔎</span>}
                        </td>
                        <td className="headerText" style={{ paddingTop: 5, paddingBottom: 5 }} > 
                          {this.props.state !== "GAME_END" && player.id === this.props.president && <img style={{ height: 18, marginTop: 5, marginBottom: 5, display: 'block' }} src={President} />}
                          {this.props.state !== "GAME_END" && player.id === this.props.chancellor && <img style={{ height: 10, marginTop: 5, marginBottom: 5, display: 'block' }} src={Chancellor} />}
                          {this.props.state !== "GAME_END" && player.id === this.props.nominated_chancellor && <img style={{ height: 20, marginTop: 5, marginBottom: 5, display: 'block' }} src={NominatedChancellor} />}
                          {player.name} 
                        </td>
                        <td style={{ textAlign: 'center', fontSize: 24, textAlign: 'right', marginRight: 5 }}>
                          {this.props.state !== "VOTING" && ""}
                          {!this.props.assassinated_players.includes(player.id) && this.props.state === "VOTING" && !this.props.transition_message && !this.props.player_voted.includes(player.id) && "💬"}
                          {!this.props.assassinated_players.includes(player.id) && this.props.state === "VOTING" && !this.props.transition_message && this.props.player_voted.includes(player.id) && "😏"}
                          {!this.props.assassinated_players.includes(player.id) && this.props.votes && this.props.state !== "GAME_END" && this.props.votes[player.id] && "✔️"}
                          {!this.props.assassinated_players.includes(player.id) && this.props.votes && this.props.state !== "GAME_END" && !this.props.votes[player.id] && "❌"}
                        </td>
                        <td style={{ textAlign: 'right', width: 75 }}>
                          {player.party === "LIBERAL" && <img src={LiberalPartyCard} style={{ objectFit: 'contain', height: '100%', maxHeight: 45, marginTop: 5 }} />}
                          {player.party === "FASCIST" && <img src={FascistPartyCard} style={{ objectFit: 'contain', height: '100%', maxHeight: 45, marginTop: 5 }} />}
                          {player.role === "LIBERAL" && <img src={LiberalRoleCard} style={{ objectFit: 'contain', height: '100%', maxHeight: 45, marginTop: 5 }} />}
                          {player.role === "FASCIST" && <img src={FascistRoleCard} style={{ objectFit: 'contain', height: '100%', maxHeight: 45, marginTop: 5 }} />}
                          {player.role === "DICTATOR" && <img src={DictatorRoleCard} style={{ objectFit: 'contain', height: '100%', maxHeight: 45, marginTop: 5 }} />}
                        </td>
                      </tr>
                      </React.Fragment>
                    )
                  })}
                </tbody>
              </table>
            </div>

            { /* /////////////////////////////////////////////// */}
            { /* //////////////   BOARDS  //////////////// */}
            { /* /////////////////////////////////////////////// */}

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={liberalBoards[this.props.num_liberal_laws_passed]} style={{ marginBottom: 0, width: '95%', flex: 1 }} />
              <img src={facistBoardsMap[Object.keys(this.props.players).length][this.props.num_fascist_laws_passed]} style={{ marginBottom: 0, width: '95%', flex: 1 }} />
            </div>

          </div>
        </div>

        <div className="center" style={{ position: 'absolute', display: 'flex', bottom: 20, left: 20, right: 20, height: 200, flexDirection: 'row' }}>

          { /* /////////////////////////////////////////////// */}
          { /* //////////////   PLAYER'S OWN ROLE  //////////////// */}
          { /* /////////////////////////////////////////////// */}

          <div style={{ flexDirection: 'row', justifyContent: 'flex-start', height: '100%', flex: 1 }} className="center">
            <div style={{ height: '100%', marginRight: 20 }}>
              {this.props.playerRole === "LIBERAL" && <img src={LiberalPartyCard} style={{ objectFit: 'contain', height: '100%' }} />}
              {(this.props.playerRole === "FASCIST" || this.props.playerRole === "DICTATOR") && <img src={FascistPartyCard} style={{ objectFit: 'contain', height: '100%' }} />}
            </div>
            <div style={{ height: '100%' }}>
              {this.props.playerRole === "LIBERAL" && <img src={LiberalRoleCard} style={{ objectFit: 'contain', height: '100%' }} />}
              {this.props.playerRole === "DICTATOR" && <img src={DictatorRoleCard} style={{ objectFit: 'contain', height: '100%' }} />}
              {this.props.playerRole === "FASCIST" && <img src={FascistRoleCard} style={{ objectFit: 'contain', height: '100%' }} />}
            </div>
          </div>

          { /* /////////////////////////////////////////////// */}
          { /* ////////////   PLAYER BALLOTS   /////////////// */}
          { /* /////////////////////////////////////////////// */}

          <div style={{ flexDirection: 'column', height: '100%' }}>
            <div style={{ flexDirection: 'row', justifyContent: 'flex-end', height: '72%', flex: 1, marginBottom: '5%' }} className="center">
              <div style={{ height: '100%', marginRight: 20 }}>
                <img
                  src={JaiVote} className="clickableCard" style={{ objectFit: 'contain', height: '100%' }}
                  onClick={() => { if (this.props.state === "VOTING" && !this.props.transition_message) socket.emit("vote", true); }}
                />
              </div>
              <div style={{ height: '100%' }}>
                <img
                  src={NeinVote} className="clickableCard" style={{ objectFit: 'contain', height: '100%' }}
                  onClick={() => { if (this.props.state === "VOTING" && !this.props.transition_message) socket.emit("vote", false); }}
                />
              </div>
            </div>
            <img src={this.props.transition_message && this.props.transition_message.includes("Election Failed") && this.props.failed_government_count === 0 ? electionTracker[3] : electionTracker[this.props.failed_government_count]} style={{ marginBottom: 0, flex: 1, height: '18%' }} />
          </div>

        </div>

      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    playerID: state.playerID,
    players: state.players,
    dictator: state.dictator,
    fascists: state.fascists,
    liberals: state.liberals,
    assassinated_players: state.assassinated_players,
    president: state.president,
    chancellor: state.chancellor,
    nominated_chancellor: state.nominated_chancellor,
    playerRole: state.playerRole,
    player_voted: state.player_voted,
    state: state.state,
    lawChoices: state.lawChoices,
    num_fascist_laws_passed: state.num_fascist_laws_passed,
    num_liberal_laws_passed: state.num_liberal_laws_passed,
    failed_government_count: state.failed_government_count,
    previous_government: state.previous_government,
    presidential_power: state.presidential_power,
    peek_cards: state.peek_cards,
    winners: state.winners,
    win_reason: state.win_reason,
    transition_message: state.transition_message,
    votes: state.votes,
    player_investigated: state.player_investigated
  }
}

const mapDispatchToProps = dispatch => {
  return {
    nominateChancellor: (playerID) => dispatch(nominateChancellor(playerID)),
    setTransition: (message) => dispatch(setTransition(message))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Game)